@if (userSg()) {
  @let submissionError =
    usersEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-centered-overlay>
    <atn-ds-widget [title]="titleSg()">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelClickHandler()"
      ></i>
      <div class="atn-admin-user__content">
        <atn-ds-text
          label="First Name"
          placeholder="Enter a First Name"
          [value]="firstNameSg()"
          (change)="updateUserPropertyHandler('firstName', $event ?? '')"
        />
        <atn-ds-text
          label="Last Name"
          placeholder="Enter a Last Name"
          [value]="lastNameSg()"
          (change)="updateUserPropertyHandler('lastName', $event ?? '')"
        />
        <atn-ds-text
          label="Email"
          placeholder="Enter an email"
          [value]="emailSg()"
          (change)="updateUserPropertyHandler('email', $event ?? '')"
        />
        <atn-ds-text
          label="Job Title"
          placeholder="Enter a Job Title"
          [value]="jobTitleSg()"
          (change)="updateUserPropertyHandler('jobTitle', $event ?? '')"
        />
        @if (showPlatformAdminFieldSg()) {
          <atn-ds-checkbox
            label="Platform Admin"
            [selected]="isPlatformAdminSg()"
            (selectedChange)="
              updateUserPropertyHandler('isPlatformAdmin', $event)
            "
          />
        }
        <atn-admin-error-message [message]="submissionError" />
      </div>
      <div
        class="atn-admin-user__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="saveClickHandler()">Save</atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
